import type { SpanFormatting } from '@/app/gridGL/HTMLGrid/inlineEditor/inlineEditorSpans';
import type { InlineEditorContentChange } from '@/app/gridGL/HTMLGrid/inlineEditor/inlineEditorInput';
import EventEmitter from 'eventemitter3';

interface EventTypes {
  status: (opened: boolean, content?: string) => void;

  replaceText: (text: string, highlight: boolean | number) => void;

  inputFailedValidation: (x: number, y: number, validationId: string) => void;

  valueChanged: (value: string) => void;

  contentChanged: (changes: InlineEditorContentChange[]) => void;

  highlightChanged: () => void;

  // Emitted when the selection formatting changes in the inline editor.
  // undefined means no selection or inline editor is closed/in formula mode.
  selectionFormatting: (formatting: SpanFormatting | undefined) => void;
}

export const inlineEditorEvents = new EventEmitter<EventTypes>();
